import { styled } from 'styled-components';

import { rem } from '@desygner/ui-common-components';

export const StyledProgressSliderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => rem(theme.Spacing.Type.Section)};
`;

export const StyledFullWidthSlider = styled.div`
  width: 100%;
`;
